import UIkit from 'uikit';

const onPageNav = () => {

  jQuery(document).ready(function($){


    UIkit.util.on('#section-nav__menu', 'active', function (e,a,c) {

      var elem = $('#section-nav__menu .uk-active a');

      var label = $(elem).text();
      var link = $(elem).attr('href');

      jQuery('.c-widget--section-nav__menu__item.--selected a').text(label);
      jQuery('.c-widget--section-nav__menu.--select').val(link).change();
    });

    jQuery('.c-widget--section-nav__menu.--select').on('change',function(e){
      if(e.originalEvent) {
        var $target = jQuery(jQuery(this).val());
        jQuery('html, body').stop().animate({
          'scrollTop': $target.offset().top - 120
        }, 900);
      }

    });
  });

};

export default onPageNav;
